import VritraIcon from "../../VritraIcon";
import {FileExplorerEntry} from "../../CordovaPlugins";


export default {
    id:"Attacher",
    parent:{
        name:"View",
        hash:"#vritra#View",
    },
    description:`
        Attachment taker
        @requires 
        <a href="https://cordova.apache.org/docs/en/12.x/reference/cordova-plugin-file/index.html">cordova-plugin-file</a>
        <a href="https://cordova.apache.org/docs/en/12.x/reference/cordova-plugin-media-capture/index.html">cordova-plugin-media-capture</a>
        <a href="#cordovaplugins#fileexplorer" target="_self">vritra-plugin-fileexplorer</a>
    `,
    props:[
        {
            name:"actionGridClassName",
            type:"string",
        },
        {
            name:"color",
            type:"string",
            description:"Attacher/actions icons color, default to black",
        },
        {
            name:"actionColor",
            type:"string",
            description:"Actions icons color",
        },
        {
            name:"actionIds",
            type:`("photo"|"video"|"image"|"file")[]`,
            description:`
                Shows and arranges the specified actions
                @"photo" : Opens the rear camera in photo mode
                @"video" : Opens the rear camera in video mode
                @"file" : Opens a file picker
                @"image" id is available only for ios because can't pick documents and images at the same time on ios
            `,
        },
        {
            name:"multiple",
            type:"boolean",
            description:`
                Allows Picking multiple files at the same time, default to true
                @Only affects the file picking action, camera and video actions always allow one file at a time
            `,
        },
        {
            name:"sinistral",
            type:"boolean",
            description:"If true, the action grid will appear on the left, default to false",
        },
        VritraIcon,
        {
            name:"onPick",
            type:"(selection:AttacherEntry|AttacherEntry[]):void",
            props:[{
                name:"AttacherEntry",
                type:"FileExplorerEntry&MediaFile",
                props:[
                    {
                        name:"MediaFile",
                        type:{
                            name:"MediaFile",
                            url:"https://cordova.apache.org/docs/en/11.x/reference/cordova-plugin-media-capture/#mediafile",
                        },
                        description:"cordova-plugin-media-capture MediaFile object"
                    },
                    FileExplorerEntry,
                ],
            }],
        },
    ],
    methods:[
        {
            name:"toggle",
            type:"(toggled:boolean):void",
            description:`
                Shows and hides the action grid.
                @if toggled true, shows the action grid otherwise hides it
                @default to a toggling behavior
            `,
        },
        {
            name:"getActionGrid",
            type:"():ActionGrid",
            description:"Returns the ActionGrid element if visible otherwise null",
            props:[{
                name:"ActionGrid",
                type:"View",
                props:[{
                    name:"unmount",
                    type:"():void",
                    description:"Same as attacher.toggle(false)",
                }],
            }],
        },
    ],
}
